"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffReminderPopup = TariffReminderPopup;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var notification_1 = require("../features/apis/notification");
var hooks_1 = require("../store/hooks");
function TariffReminderPopup() {
    var _this = this;
    var _a, _b;
    var clientId = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }).clientId;
    var _c = (0, react_3.useState)(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = (0, react_3.useState)(false), hasShownThisSession = _d[0], setHasShownThisSession = _d[1];
    var data = (0, notification_1.useFetchNotificationsQuery)({ clientId: clientId }, { skip: !clientId }).data;
    var _e = (0, notification_1.useDismissNotificationMutation)(), dismissNotification = _e[0], isDismissing = _e[1].isLoading;
    var markAsRead = (0, notification_1.useMarkAsReadMutation)()[0];
    var tariffReminder = ((_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.notifications) !== null && _b !== void 0 ? _b : []).find(function (n) { var _a; return (_a = n.source) === null || _a === void 0 ? void 0 : _a.startsWith("TARIFF_REMINDER_"); });
    (0, react_3.useEffect)(function () {
        if (tariffReminder && !hasShownThisSession) {
            setIsOpen(true);
            setHasShownThisSession(true);
        }
    }, [tariffReminder, hasShownThisSession]);
    var handleAlreadyUploaded = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tariffReminder)
                        return [2 /*return*/];
                    return [4 /*yield*/, dismissNotification({ _id: tariffReminder._id })];
                case 1:
                    _a.sent();
                    setIsOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRemindLater = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(tariffReminder && !tariffReminder.isRead)) return [3 /*break*/, 2];
                    return [4 /*yield*/, markAsRead({ _id: tariffReminder._id })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    setIsOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    if (!tariffReminder || !isOpen)
        return null;
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { disableAnimation: true, isOpen: true, onClose: handleRemindLater, size: "md", backdrop: "opaque", isDismissable: true, children: (0, jsx_runtime_1.jsxs)(react_1.ModalContent, { children: [(0, jsx_runtime_1.jsxs)(react_1.ModalHeader, { className: "flex items-center gap-3 pb-2", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex h-10 w-10 items-center justify-center rounded-full bg-amber-100", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:upload-minimalistic-bold", className: "text-xl text-amber-600" }) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { className: "text-lg font-semibold text-gray-900", children: tariffReminder.title }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs font-normal text-gray-500", children: "Annual Tariff Reminder" })] })] }), (0, jsx_runtime_1.jsxs)(react_1.ModalBody, { children: [(0, jsx_runtime_1.jsx)("div", { className: "rounded-lg border border-amber-200 bg-amber-50 p-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-3", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:shield-warning-bold", className: "mt-0.5 shrink-0 text-lg text-amber-500" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-700", children: tariffReminder.message })] }) }), (0, jsx_runtime_1.jsx)("p", { className: "mt-2 text-xs text-gray-500", children: "This reminder will keep appearing until you confirm the new tariffs have been uploaded. If you have already uploaded them, click \"Already Uploaded\" to dismiss this reminder for the year." })] }), (0, jsx_runtime_1.jsxs)(react_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: handleRemindLater, children: "Remind Me Later" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", isLoading: isDismissing, onPress: handleAlreadyUploaded, startContent: !isDismissing ? (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:check-circle-bold", className: "text-lg" }) : undefined, children: "Already Uploaded" })] })] }) }));
}
